import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import {
  Card,
  Col,
  Row,
  Tooltip,
  Select,
  Space,
  Form,
  DatePicker,
  Typography,
  Spin,
} from "antd";
import upload from "../../../assets/images/upload.svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import {
  TotalCustomerChart,
  CustomerPieChart,
  OffloadingWaitTimeChart,
  TimeAfterLoadingPieChart,
  LoadingTimeChart,
  CompainedAreaChart,
  CompainedAreaChart2,
  TimeAfterBarchart,
} from "../CustomerReport/CustomerChart";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import dayjs from "dayjs";
const { Text } = Typography;

const Customerreportstyle = styled.div`
  .head {
    color: #5f6d8c;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between !important;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
  .badg {
    padding: 5px;
  }
  .badg .ant-badge-count {
    font-size: 12px; /* Adjust the count number size */
    height: 16px; /* Decrease the outer circle height */
    min-width: 16px; /* Decrease the outer circle width */
    line-height: 16px; /* Center the count text vertically */
  }

  .plc .ant-select-selection-placeholder {
    color: black !important; /* Set placeholder text color to black */
  }

  .plc .ant-select-arrow {
    color: black; /* Set dropdown arrow color to black */
  }

  .ant-card-head {
    border-bottom: none;
  }
  .topcustomer-content {
    display: flex;
    align-item: center;
    justify-content: space-between;
    background-color: yellowgreen;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  },
`;

const topcustomercolors = [
  "#00BC13",
  "#DEE640",
  "#FC8954",
  "#0090EA",
  "#89C8FF",
];
// const bottomcustomerdata = [
//   { CompanyName: "Pwani Oil Mombasa", value: 25 },
//   { CompanyName: "Edible Oil Products", value: 24 },
//   { CompanyName: "Adesh Limited", value: 20 },
//   { CompanyName: "Golden Africa Kenya", value: 15 },
//   { CompanyName: "New Oswal", value: 10 },
// ];
const bottomcustomercolors = [
  "#04A093",
  "#40E6E4",
  "#0090BC",
  "#89C0FF",
  "#22A5F6",
];
//time after loading(Hr) PieChart colors
const TimeAfterTopcolors = [
  "#89C8FF",
  "#00EAE6",
  "#E373FF",
  "#40E659",
  "#94FF5F",
];
const TimeAfterBottomcolors = [
  "#E3DC1B",
  "#1BEA00",
  "#FF8B73",
  "#F46ECE",
  "#84D6FC",
];

const CustomerReport = () => {
  const [visible, setVisible] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [chartData, setChartData] = useState([]);
  const [loadingchartData, setloadingchartData] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("CUSTRPT", "EX"),
    [reduxPermissions],
  );
  const handleTooltipVisibleChange = (visible) => {
    setVisible(visible);
  };
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const getCustomerChart = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `customer/get_CustomerReport?MCID=${userInfo.MCID}&startDate=${dayjs(
        selectedDate?.[0],
      ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
        "YYYY-MM-DD",
      )}`,
    );

    console.log("data--->", data);
    setChartData(data);
    setLoading(false);
  };
  const getCustomerChart2 = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `customer/get_loadingtime_report?MCID=${userInfo.MCID}&startDate=${dayjs(
        selectedDate?.[0],
      ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
        "YYYY-MM-DD",
      )}`,
    );

    console.log("data--->", data);
    setloadingchartData(data);
    setLoading(false);
  };

  useEffect(() => {
    if (selectedDate?.length === 2) {
      setDateRange(selectedDate);
      getCustomerChart();
      getCustomerChart2();
    }
  }, [selectedDate, userInfo]);

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  return (
    <div style={{ width: "100%" }}>
      <Customerreportstyle style={{ width: "100%" }}>
        <Row style={{ width: "100%" }}>
          <Col sm={24} xl={24} md={24}>
            <Card>
              <div className="total">
                <div>Overiew</div>
                <div className="Custom">
                  <div className="dropstyle">
                    {" "}
                    <Form.Item
                      label=""
                      name="dropdown"
                      rules={[
                        { required: true, message: "Please select an option!" },
                      ]}
                    >
                      <Select
                        placeholder="Custom Range"
                        className="plc"
                        style={{ width: "240px" }}
                        defaultValue={duration}
                        onChange={(values) => {
                          setDuration(values);
                        }}
                      >
                        {Duration.map((item) => (
                          <Option key={item.value} value={item.value}>
                            {item?.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="dropstyle1">
                    <Space direction="vertical" size={12}>
                      <RangePicker
                        value={selectedDate}
                        onChange={(date, dateString) => setSelectedDate(date)}
                      />
                    </Space>
                  </div>
                  {/* <div>
                    <Tooltip
                      title="Export"
                      placement="bottom"
                      arrow={false}
                      visible={visible}
                      onVisibleChange={handleTooltipVisibleChange}
                      //   overlayInnerStyle={{
                      //     backgroundColor: "transparent",
                      //     color: "#5f6d8c",
                      //     boxShadow: "none",
                      //   }}
                    >
                      <img
                        src={upload}
                        alt="Upload Icon"
                        className="hover-image"
                        onClick={() => handleDownloadChart("Export Chart")}
                      />
                    </Tooltip>
                  </div> */}
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <Row style={{ width: "100%" }}>
          <Col sm={24} xl={24} md={24} className="mt-3" id="Export Chart">
            <Spin spinning={loading}>
              <Card
                style={{ width: "100%" }}
                title={
                  <div className="chart-header">
                    <span>
                      Total Customer (Consignee)
                      <span
                        style={{
                          fontSize: "32px",
                          marginLeft: "20px",
                          alignContent: "center",
                        }}
                      >
                        {chartData?.CustomerTotal?.length || 0}
                      </span>
                    </span>
                    <div>
                      <img
                        src={ExportIcon}
                        alt="Export"
                        style={{
                          width: "20px",
                          height: "20px",
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                          backgroundColor: "#EBF7ED",
                          borderRadius: "6px",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart("Export Chart", "Total Customer");
                        }}
                      />
                    </div>
                  </div>
                }
              >
                <TotalCustomerChart
                  data={chartData.CustomerTotal ? chartData.CustomerTotal : []}
                  style={{ width: "100%", height: "350px" }}
                />
              </Card>
            </Spin>
          </Col>
        </Row>
        <div id="Export Chart1">
          <Card
            className="w-100 mt-3"
            title={
              <div className="chart-header">
                <div className="total">
                  <span>Offloading Time (Hr)</span>
                </div>
                <div>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart("Export Chart1", "Offloading Time");
                    }}
                  />
                </div>
              </div>
            }
          >
            <Row gutter={16}>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Top 5 Customers</h6>

                    <CustomerPieChart
                      data={
                        Array.isArray(chartData.TopOffloading)
                          ? chartData.TopOffloading
                          : []
                      }
                      colors={topcustomercolors}
                      width="100%" // Make sure your chart supports this prop
                      height={350}
                    />
                  </Card>
                </Spin>
              </Col>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Bottom 5 Customers</h6>

                    <CustomerPieChart
                      // Forces re-render
                      data={
                        Array.isArray(chartData.BottomOffloading)
                          ? chartData.BottomOffloading
                          : []
                      }
                      width="100%"
                      height={350}
                      // data={bottomcustomerdata}
                      colors={bottomcustomercolors}
                    />
                  </Card>
                </Spin>
              </Col>
            </Row>
          </Card>
        </div>
        <div id="Export Chart2">
          <Card
            className="mt-3"
            title={
              <div className="chart-header">
                <div className="total">
                  <span>Offloading Wait Time (Hr)</span>
                </div>
                <div>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart2",
                        "Offloading Wait Time",
                      );
                    }}
                  />
                </div>
              </div>
            }
          >
            <Row gutter={16}>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Top 5 Customers</h6>

                    {chartData?.TopOffloadingwaitingTime && (
                      <OffloadingWaitTimeChart
                        data={
                          Array.isArray(chartData.TopOffloadingwaitingTime)
                            ? chartData.TopOffloadingwaitingTime
                            : []
                        }
                        width={"100%"}
                        height={350}
                        barColor="#C090FF"
                      />
                    )}
                  </Card>
                </Spin>
              </Col>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Bottom 5 Customers</h6>

                    {chartData?.BottomOffloadingWaitingTime && (
                      <OffloadingWaitTimeChart
                        data={
                          Array.isArray(chartData.BottomOffloadingWaitingTime)
                            ? chartData.BottomOffloadingWaitingTime
                            : []
                        }
                        width={"100%"}
                        height={350}
                        barColor="#FCD570"
                      />
                    )}
                  </Card>
                </Spin>
              </Col>
            </Row>
          </Card>
        </div>
        <div id="Export Chart3">
          <Card
            className="mt-3"
            title={
              <div className="chart-header">
                <div className="total">
                  <span>Time After Offloading(Hr)</span>
                </div>
                <div>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart3",
                        "Offloading Wait Time",
                      );
                    }}
                  />
                </div>
              </div>
            }
          >
            <Row gutter={16}>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Top 5 Customers</h6>

                    {chartData?.TopAfterOffloading && (
                      <TimeAfterLoadingPieChart
                        data={
                          Array.isArray(chartData.TopAfterOffloading)
                            ? chartData.TopAfterOffloading
                            : []
                        }
                        colors={TimeAfterTopcolors}
                        width="100%"
                        height={250}
                      />
                    )}
                  </Card>
                </Spin>
              </Col>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Bottom 5 Customers</h6>

                    {chartData?.BottomAfterOffloading && (
                      <TimeAfterLoadingPieChart
                        data={
                          Array.isArray(chartData.BottomAfterOffloading)
                            ? chartData.BottomAfterOffloading
                            : []
                        }
                        colors={TimeAfterBottomcolors}
                        width="100%"
                        height={250}
                      />
                    )}
                  </Card>
                </Spin>
              </Col>
            </Row>
          </Card>
        </div>
        <div id="Export Chart4">
          <Card
            className="mt-3"
            title={
              <div className="chart-header">
                <div className="total">
                  <span>Loading Time(Hr)</span>
                </div>
                <div>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart("Export Chart4", "Loading Time");
                    }}
                  />
                </div>
              </div>
            }
          >
            <Row gutter={16}>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Top 5 Customers</h6>

                    {loadingchartData?.LoadingTimeTop && (
                      <LoadingTimeChart
                        data={
                          Array.isArray(loadingchartData.LoadingTimeTop)
                            ? loadingchartData.LoadingTimeTop
                            : []
                        }
                        color="#126DF6"
                        width="100%"
                        height={250}
                      />
                    )}
                  </Card>
                </Spin>
              </Col>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Bottom 5 Customers</h6>

                    {loadingchartData?.LoadingTimeBottom && (
                      <LoadingTimeChart
                        data={
                          Array.isArray(loadingchartData.LoadingTimeBottom)
                            ? loadingchartData.LoadingTimeBottom
                            : []
                        }
                        color="#09D982"
                        width="100%"
                        height={250}
                      />
                    )}
                  </Card>
                </Spin>
              </Col>
            </Row>
          </Card>
        </div>
        <div id="Export Chart5">
          <Card
            className="mt-3"
            title={
              <div className="chart-header">
                <div className="total">
                  <span>Loading Waiting Time(Hr)</span>
                </div>
                <div>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart5",
                        "Loading Waiting Time",
                      );
                    }}
                  />
                </div>
              </div>
            }
          >
            <Row gutter={16}>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Top 5 Customers</h6>

                    {loadingchartData?.LoadingWaitingTimeTop && (
                      <CompainedAreaChart
                        data={
                          Array.isArray(loadingchartData.LoadingWaitingTimeTop)
                            ? loadingchartData.LoadingWaitingTimeTop
                            : []
                        }
                        width="100%"
                      ></CompainedAreaChart>
                    )}
                  </Card>
                </Spin>
              </Col>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Bottom 5 Customers</h6>

                    {loadingchartData?.LoadingWaitingTimeBottom && (
                      <CompainedAreaChart2
                        data={
                          Array.isArray(
                            loadingchartData.LoadingWaitingTimeBottom,
                          )
                            ? loadingchartData.LoadingWaitingTimeBottom
                            : []
                        }
                        width="100%"
                      ></CompainedAreaChart2>
                    )}
                  </Card>
                </Spin>
              </Col>
            </Row>
          </Card>
        </div>
        <div id="Export Chart6">
          <Card
            className="mt-3"
            title={
              <div className="chart-header">
                <div className="total">
                  <span>Time After Loading(Hr)</span>
                </div>
                <div>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                      backgroundColor: "#EBF7ED",
                      borderRadius: "6px",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart6",
                        "Time After Loading",
                      );
                    }}
                  />
                </div>
              </div>
            }
          >
            <Row gutter={16}>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Top 5 Customers</h6>

                    {loadingchartData?.TimeAfterLoadingTop && (
                      <TimeAfterBarchart
                        data={
                          Array.isArray(loadingchartData.TimeAfterLoadingTop)
                            ? loadingchartData.TimeAfterLoadingTop
                            : []
                        }
                        width="100%"
                        height={300}
                        color="#00A9BC"
                      ></TimeAfterBarchart>
                    )}
                  </Card>
                </Spin>
              </Col>
              <Col sm={24} md={12} xl={12}>
                <Spin spinning={loading}>
                  <Card>
                    <h6>Bottom 5 Customers</h6>

                    {loadingchartData?.TimeAfterLoadingBottom && (
                      <TimeAfterBarchart
                        data={
                          Array.isArray(loadingchartData.TimeAfterLoadingBottom)
                            ? loadingchartData.TimeAfterLoadingBottom
                            : []
                        }
                        width="100%"
                        height={300}
                        color="#52ED86"
                      ></TimeAfterBarchart>
                    )}
                  </Card>
                </Spin>
              </Col>
            </Row>
          </Card>
        </div>
      </Customerreportstyle>
    </div>
  );
};

export default CustomerReport;
